import { defineMessages } from 'react-intl'

/**
 * Tour style names, “Key benefits” copy, and tour-UX strings — `docs/product-taxonomy.md` §7.
 * Pair with `useTourStyledLabels` / `useTourStyleBenefits` for headings already inlined there.
 */
const tourGlossaryMessages = defineMessages({
  deluxeTours: {
    id: 'dHUnXgQ7nMqRg_ohkf8u',
    defaultMessage: 'Deluxe Tours',
  },
  premiumTours: {
    id: 'PyZp5DtcHRPJ_kdD-nB3',
    defaultMessage: 'Premium Tours',
  },
  signatureSeriesTours: {
    id: 'KK-ng704V1N6RbM6-RBa',
    defaultMessage: 'Signature Series',
  },
  insiderSeriesTours: {
    defaultMessage: 'Insider Series Tours',
    id: 'nCK-jFI8LsRT_PXYduFN',
  },
  ultraLuxTours: {
    id: 'Zr_5o6AxrNXLAhDAui0Y',
    defaultMessage: 'Ultra Lux Tours',
  },
  privateDeluxeTours: {
    defaultMessage: 'Private Deluxe Tours',
    id: '0TtDAItXN0Ops1JZADFr',
  },
  privatePremiumTours: {
    defaultMessage: 'Private Premium Tours',
    id: 'mcArzAmecNsi3LoE7GaT',
  },
  privateSignatureSeriesTours: {
    defaultMessage: 'Private Signature Series Tours',
    id: 'FTJOLg5mfdrA0ok5Rpbs',
  },
  privateInsiderSeriesTours: {
    defaultMessage: 'Private Insider Series Tours',
    id: 'MFCwgUIbmhTJlhdswxo7',
  },
  privateUltraLuxTours: {
    defaultMessage: 'Private Ultra Lux Tours',
    id: 'I62GY03s_FbqSaDrBmYg',
  },
  keyBenefitsOf: {
    defaultMessage: 'Key Benefits of {tourVariantName}',
    id: 'QqnfeKvO-uiwZSsVAniC',
  },
  toursConcierge: {
    defaultMessage: 'Tours Concierge',
    id: 'wt7EMrSVk5Jp3a6UEjTs',
  },
  preTourAccommodationIn: {
    defaultMessage: 'Pre-tour accommodation in {location}',
    id: 'GjpEu5u0jQyidbZiRv8N',
  },
  postTourAccommodationIn: {
    defaultMessage: 'Post-tour accommodation in {location}',
    id: '4_rzAcIUd-KSInHa6bvv',
  },
  tourPlusFlightsPackage: {
    defaultMessage: 'Tour + flights package available',
    id: 'CaPpoUkWpCltU94a7SnF',
  },
  putTourOnHold: {
    defaultMessage: 'Put tour on hold',
    id: 'iaSbsJcuQYnYMsLX3gcE',
  },
  removeTour: {
    defaultMessage: 'Remove tour',
    id: 'mddJWoQQ_wRHfvbg1itc',
  },
  extrasOnYourTour: {
    defaultMessage: 'Extras on your tour',
    id: 'nuiRlRfGn3m7QaGj6jFY',
  },
  privateTour: {
    defaultMessage: 'Private tour',
    id: 'y59ehJqEchYieT2zE7AO',
  },
  smallGroupTour: {
    defaultMessage: 'Small group tour',
    id: 'pqPcse8RsgxR9UilKj-2',
  },
  largeGroupTour: {
    defaultMessage: 'Large group tour',
    id: '-ZI0P_VOXj2sr_sPAy7X',
  },
  familyFriendlyTour: {
    defaultMessage: 'Family friendly tour',
    id: 'Dk-jbNRC6plcOwu4zMXr',
  },
})

export default tourGlossaryMessages
